import Footer from "@components/Footer";
import Header from "@components/Header";
import Banner from "@components/Banner";
import Breadcrumbs from "@components/Breadcrumbs";
import { useRouteContext } from "@providers/RouteProvider";
import LegalNotice from "@components/LegalNotice";
import { usePageContext } from "@providers/PageProvider";
import helper from "@utils/helper";
import _ from "lodash";

const View = () => {
  const { router } = useRouteContext();
  const { pageData } = usePageContext();
  const banner = helper.formatBanner(pageData);

  return (
    <div className="bg-withe" data-scroll-container>
      <Header />
      <Banner
        image={_.get(banner, "image")}
        title={_.get(banner, "title")}
        description={_.get(banner, "content")}
      />
      <Breadcrumbs data={router.breadcrumbs("privacy", {})} />
      <LegalNotice />
      <Footer hideSocialIcons />
    </div>
  );
};

export default View;
